import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { editCollectionRegister } from '../../../redux/actions/form';
import { useEffect } from 'react';
import { getDateTime } from '../../../utility/helpers/DateTime/formatDate';
import { DocumentTable } from './addons/DocumentTable';
import { useDropzone } from 'react-dropzone';
import { useMemo } from 'react';
const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '10px',
  paddingTop: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  fontSize: '12px',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const focusedStyle = { borderColor: '#2196f3' };
const acceptStyle = { borderColor: '#00e676' };
const rejectStyle = { borderColor: '#ff1744' };

export const DocumentationInterpreter = (props) => {
  const { endPoint, collection } = props;
  const dispatch = useDispatch();
  const { id } = useParams();
  const { documents = [], files = [] } = useSelector((state) => state.form);

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone();

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  useEffect(() => {
    if (acceptedFiles.length !== 0) {
      dispatch(
        editCollectionRegister([], {
          name: 'documents',
          value: [
            ...documents,
            ...acceptedFiles
              .filter((f) => !documents.some((s) => s.path === f.path))
              .map((m) => {
                return {
                  path: m.name,
                  name: m.name,
                  type: m.type,
                  size: m.size,
                  date: getDateTime(m.lastModifiedDate || new Date()),
                };
              }),
          ],
        }),
      );
      dispatch(
        editCollectionRegister([], {
          name: 'files',
          value: [
            ...files,
            ...acceptedFiles.filter(
              (f) => !files.some((s) => s.path === f.path),
            ),
          ],
        }),
      );
    }
  }, [acceptedFiles]);

  return (
    <>
      <div className={`col-12`}>
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p>Arrastra los archivos aqui o haz clic para seleccionarlos</p>
        </div>

        <DocumentTable
          documents={documents}
          collection={collection}
          endPoint={endPoint}
          id={id}
          targetId={props.targetId}
        />
      </div>
    </>
  );
};
